// extracted by mini-css-extract-plugin
export default {"MainAlert":"MainAlert_MainAlert__5DdO0","Title":"MainAlert_Title__AZxN0","Description":"MainAlert_Description__pKfA6"};